export default "__VITE_ASSET__Dyxve7cW__"